// extracted by mini-css-extract-plugin
module.exports = {"verifyButton":"EmailVerification_verifyButton__372LP","subInputText":"EmailVerification_subInputText__1DCE7"};